import { useQuery } from '@tanstack/react-query';
import { apiRequest, apiEnabled } from '../lib/api';

// Curated Instagram/TikTok posts, added by the admin in Ajustes → Redes sociales.
// No static fallback: without a backend there is nothing to show, so the
// Home section simply stays hidden (see SocialFeed.jsx).
export function useSocialFeed() {
  return useQuery({
    queryKey: ['social-feed'],
    queryFn: () => apiRequest('/api/social-feed'),
    enabled: apiEnabled,
    staleTime: 5 * 60 * 1000,
  });
}
